//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.SectionAnalysis.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.CombOptionsBuilder.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.CurveAlignedBuilder.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.IsoparametricBuilder.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.ParallelPlanesExBuilder.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.RadialBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectPointList.js";
import "../GeometricAnalysis/GeometricAnalysis.SectionAnalysis.XYZPlaneBuilder.js";
import "../no/GeometricAnalysis.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Alignment",1,0],[0,"CalculationMethod",1,0],[1,"CombOptions",0,"GeometricUtilities.CombOptionsBuilder",0],[1,"CurveAligned",0,"GeometricAnalysis.SectionAnalysis.CurveAlignedBuilder",0],[0,"Interactive",0,"GeometricAnalysis.SectionAnalysis.InteractiveBuilder",0],[0,"IsShowInflectionPointsEnabled",1,0],[0,"IsShowLengthEnabled",1,0],[0,"IsShowPeakPointsEnabled",1,0],[1,"Isoparametric",0,"GeometricAnalysis.SectionAnalysis.IsoparametricBuilder",0],[0,"NeedleDirection",1,0],[0,"Output",1,0],[1,"ParallelPlanes",0,"GeometricAnalysis.SectionAnalysis.ParallelPlanesExBuilder",0],[0,"Placement",1,0],[1,"Radial",0,"GeometricAnalysis.SectionAnalysis.RadialBuilder",0],[0,"ScalingMethod",1,0],[1,"SelectObject",0,"SelectTaggedObjectList",0],[1,"SpecifyPoint",0,"SelectPointList",0],[1,"XYZPlane",0,"GeometricAnalysis.SectionAnalysis.XYZPlaneBuilder",0]],[],[]];
SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder.PlacementType = Object.freeze({
    "Uniform" : "Uniform", "ThroughPoints" : "ThroughPoints", "BetweenPoints" : "BetweenPoints", "Interactive" : "Interactive"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder.AlignmentType = Object.freeze({
    "XYZPlane" : "XYZPlane", "ParallelPlanes" : "ParallelPlanes", "CurveAligned" : "CurveAligned", "Isoparametric" : "Isoparametric", "Radial" : "Radial"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder.OutputType = Object.freeze({
    "AnalysisObject" : "AnalysisObject", "SectionCurves" : "SectionCurves", "Both" : "Both"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder.NeedleDirectionType = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder.CalculationMethodType = Object.freeze({
    "Curvature" : "Curvature", "RadiusofCurvature" : "RadiusofCurvature"});

SPLM.GeometricAnalysis.SectionAnalysis.SectionAnalysisExBuilder.ScalingMethodType = Object.freeze({
    "Linear" : "Linear", "Logarithmic" : "Logarithmic"});

export default SPLM;